import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../components/dashboard-layout";
import { useAuth } from "../App";
import api from "../api";

const SECTIONS = [
  {
    title: "C. Efikasi Diri Kreatif dalam Merancang Proyek STEAM dengan AiDuNode",
    description: "Diadaptasi dari Lamb, Boedeker, & Kettler, 2025",
    questions: [
      { id: "q1",  text: "Saya merasa percaya diri saat mengerjakan tugas-tugas kreatif, seperti merancang proyek STEAM dengan bantuan AiDuNode." },
      { id: "q2",  text: "Saya yakin memiliki kemampuan berinovasi dan mendesain solusi, khususnya ketika memanfaatkan AiDuNode untuk proyek berbasis Arduino dan IoT." },
      { id: "q3",  text: "Saya tetap percaya pada gagasan saya sendiri, meskipun terdengar tidak lazim, saat mengembangkan proyek dengan bantuan AiDuNode." },
      { id: "q4",  text: "Ketika sebuah proyek terasa rumit, saya mampu menemukan solusi kreatif dengan memanfaatkan bantuan AiDuNode." },
      { id: "q5",  text: "Saya tidak mudah menyerah saat mengerjakan proyek kreatif berbasis Arduino/IoT menggunakan AiDuNode." },
      { id: "q6",  text: "Saya merasa lebih kreatif dibandingkan rekan-rekan saya dalam menghasilkan ide dan desain inovatif menggunakan AiDuNode." },
      { id: "q7",  text: "Saya yakin dapat mengerjakan tugas kreatif sama baik atau lebih baik dari mahasiswa lain di jurusan saya ketika menggunakan AiDuNode." },
      { id: "q8",  text: "Saya percaya diri dapat memimpin tim dalam merancang proyek STEAM berbasis Arduino dan IoT dengan bantuan AiDuNode." },
      { id: "q9",  text: "Saya tetap mengejar ide kreatif saya meski mengalami kegagalan, terutama saat mencoba fitur-fitur baru di AiDuNode." },
      { id: "q10", text: "Saya tidak mudah melepaskan gagasan kreatif saya terkait pemanfaatan AiDuNode, walau menghadapi kendala teknis." },
      { id: "q11", text: "Saya tetap membagikan ide kreatif saya tentang penggunaan AiDuNode kepada orang lain, meskipun pernah menerima kritik." },
      { id: "q12", text: "Saya mampu mendiskusikan proyek inovatif saya yang memanfaatkan AiDuNode dengan pakar atau praktisi di bidangnya." },
      { id: "q13", text: "Dalam proyek kelompok, saya cukup mahir menghasilkan ide unik, terutama saat mengombinasikan AiDuNode dengan perangkat IoT." },
      { id: "q14", text: "Saya dapat berpikir kreatif di berbagai situasi, baik saat belajar di kelas maupun saat merancang proyek STEAM dengan AiDuNode." },
      { id: "q15", text: "Saya percaya diri mempresentasikan ide, temuan, atau rancangan proyek yang melibatkan AiDuNode kepada rekan sejawat." },
      { id: "q16", text: "Saya mampu menghasilkan gagasan baru dalam memanfaatkan AiDuNode untuk meningkatkan pembelajaran dan keterlibatan siswa." },
      { id: "q17", text: "Setelah mengalami kegagalan, saya tetap berusaha menyampaikan solusi inovatif yang memanfaatkan AiDuNode." },
      { id: "q18", text: "Saya percaya diri melaksanakan dan mempresentasikan proyek berbasis AiDuNode di hadapan audiens." },
      { id: "q19", text: "Saya mampu menghasilkan berbagai alternatif ide untuk memanfaatkan AiDuNode dalam menyelesaikan masalah dan melibatkan siswa." },
      { id: "q20", text: "Saya merasa percaya diri mempresentasikan ide dan rancangan proyek berbasis AiDuNode kepada rekan maupun atasan." },
    ],
  },
  {
    title: "D. Dukungan Dosen yang Dirasakan dalam Penggunaan AiDuNode",
    description: "Diadaptasi dari Liu, Gong, Zhang, Yu, & Zhou, 2021",
    questions: [
      { id: "q21", text: "Universitas saya mendorong penggunaan pendekatan kreatif, termasuk pemanfaatan AiDuNode, dalam pembelajaran fisika berbasis STEAM." },
      { id: "q22", text: "Saya memperoleh dukungan dari sesama dosen saat menggunakan AiDuNode sebagai alat bantu pembelajaran proyek STEAM." },
      { id: "q23", text: "Universitas saya menyediakan sumber daya yang memadai untuk mendukung pemanfaatan AiDuNode dalam kegiatan pembelajaran kreatif." },
      { id: "q24", text: "Program pengembangan profesional di universitas saya membantu saya mengembangkan keterampilan mengajar fisika berbasis STEAM dengan memanfaatkan AiDuNode." },
      { id: "q25", text: "Saya merasa dihargai dan didukung ketika menerapkan ide-ide baru, seperti memanfaatkan AiDuNode, dalam pengajaran fisika berbasis STEAM." },
    ],
  },
  {
    title: "E. Efektivitas dan Persepsi terhadap AiDuNode dalam Pembelajaran Coding untuk Proyek STEAM",
    description: "",
    questions: [
      { id: "q26", text: "AiDuNode membantu mahasiswa memahami konsep pemrograman Arduino/ESP32 dengan lebih baik melalui panduan interaktif dalam proyek STEAM." },
      { id: "q27", text: "Penggunaan AiDuNode meningkatkan motivasi dan keterlibatan mahasiswa dalam belajar pemrograman melalui pengalaman praktik proyek STEAM." },
      { id: "q28", text: "AiDuNode membuat proses belajar pemrograman untuk proyek STEAM terasa lebih menyenangkan melalui pendekatan pemecahan masalah yang inovatif." },
      { id: "q29", text: "AiDuNode secara efektif mendukung pengembangan keterampilan pemrograman mahasiswa melalui proyek STEAM berbasis Arduino dan IoT." },
    ],
  },
  {
    title: "F. Ketergantungan Mahasiswa pada AiDuNode saat Pemecahan Masalah",
    description: "Diadaptasi dari Hou, Zhu, Sudarshan, Lim, & Ong, 2025",
    questions: [
      { id: "q30", subTitle: "F.1 Penggunaan Reflektif",         text: "Saya menyusun sendiri prompt atau strategi bertanya kepada AiDuNode agar memperoleh output yang sesuai kebutuhan proyek STEAM saya." },
      { id: "q31", text: "Saya mengevaluasi secara kritis jawaban yang diberikan AiDuNode untuk memastikan kesesuaiannya dengan tujuan proyek saya." },
      { id: "q32", text: "Saya mengubah cara saya berinteraksi dengan AiDuNode agar mendapatkan output yang lebih akurat untuk proyek Arduino/IoT saya." },
      { id: "q33", text: "Saya meminta AiDuNode untuk menyempurnakan solusi awal saya, khususnya pada bagian integrasi perangkat IoT." },
      { id: "q34", subTitle: "F.2 Penggunaan Secara Hati-hati",   text: "Saya berhasil menemukan kesalahan atau ketidaksesuaian pada jawaban yang diberikan AiDuNode dalam proyek STEAM saya." },
      { id: "q35", text: "Saya menyadari bahwa saran dari AiDuNode tidak selalu sesuai sepenuhnya dengan kebutuhan teknis proyek saya." },
      { id: "q36", text: "Saya mengabaikan output AiDuNode apabila dirasa tidak cocok digunakan dalam proyek STEAM saya, terutama terkait integrasi IoT." },
      { id: "q37", text: "Saya menyelesaikan bagian tertentu dari proyek saya secara mandiri tanpa bergantung pada AiDuNode ketika saya sudah yakin dengan solusinya." },
      { id: "q38", subTitle: "F.3 Penggunaan Tanpa Pertimbangan", text: "Saya menyalin deskripsi proyek atau soal langsung ke AiDuNode tanpa menyesuaikannya dengan kebutuhan proyek STEAM saya." },
      { id: "q39", text: "Saya langsung memakai jawaban AiDuNode dalam proyek saya tanpa penyesuaian berarti, terutama untuk tugas pemrograman atau solusi IoT." },
      { id: "q40", text: "Saya menghabiskan cukup banyak waktu berinteraksi dengan AiDuNode tanpa benar-benar mempertimbangkan kaitan solusinya dengan proyek IoT saya." },
      { id: "q41", text: "Saya menggunakan hasil dari AiDuNode tanpa perubahan berarti atau tanpa memikirkan konsekuensinya terhadap komponen IoT proyek saya." },
      { id: "q42", subTitle: "F.4 Penggunaan Secara Kolaboratif", text: "Teman-teman saya membantu menemukan kesalahan pada output AiDuNode saat mengerjakan bagian IoT dari proyek STEAM saya." },
      { id: "q43", text: "Teman-teman saya membantu saya menyesuaikan output AiDuNode agar cocok dengan kebutuhan proyek STEAM kelompok kami." },
      { id: "q44", text: "Saya meminta masukan atau klarifikasi dari teman saat menggunakan AiDuNode dalam proyek STEAM." },
      { id: "q45", text: "Teman-teman saya memberi wawasan berharga yang membantu saya menyempurnakan pemanfaatan AiDuNode untuk fungsi IoT dalam proyek saya." },
    ],
  },
  {
    title: "G. Gaya Kreativitas dalam Proyek STEAM Berbasis AiDuNode",
    description: "Diadaptasi dari Kumar, Kemmler, & Holman, 1997",
    questions: [
      { id: "q46", subTitle: "G.1 Keyakinan pada Proses Bawah Sadar",  text: "Saya sering menemukan solusi kreatif dalam proyek STEAM secara tiba-tiba, terutama ketika sedang menggunakan AiDuNode." },
      { id: "q47", text: "Saat menggunakan AiDuNode, saya kadang mendapat wawasan yang sulit saya jelaskan namun membantu menemukan solusi baru." },
      { id: "q48", text: "Saya merasa AiDuNode dapat membantu saya mencapai terobosan meskipun saya tidak sepenuhnya memahami cara kerjanya." },
      { id: "q49", text: "Ide kreatif kerap muncul begitu saja saat saya bekerja dengan AiDuNode, tanpa saya sengaja memikirkannya." },
      { id: "q50", text: "Saya merasa proses kreatif saya dalam proyek STEAM kadang dipandu oleh intuisi saat menggunakan AiDuNode." },
      { id: "q51", subTitle: "G.2 Penggunaan Teknik Tertentu",          text: "Saya memadukan saran dari AiDuNode dengan data sensor IoT dan ide-ide baru untuk menghasilkan solusi proyek STEAM yang inovatif." },
      { id: "q52", text: "Saya memanfaatkan AiDuNode untuk brainstorming dan menemukan ide baru dalam tugas berbasis STEAM." },
      { id: "q53", text: "Saya senang mencoba cara-cara tidak lazim dengan AiDuNode untuk memecahkan masalah proyek yang kompleks." },
      { id: "q54", text: "Saya mengerjakan beberapa aspek proyek secara bersamaan dengan memanfaatkan AiDuNode untuk mengeksplorasi berbagai kemungkinan kreatif." },
      { id: "q55", text: "Saya menerapkan teknik tertentu saat berinteraksi dengan AiDuNode untuk menyempurnakan ide dan solusi proyek saya." },
      { id: "q56", subTitle: "G.3 Pemanfaatan Orang Lain",              text: "Saat menemui kendala dengan AiDuNode, saya berkonsultasi dengan rekan atau dosen untuk melanjutkan proyek STEAM saya." },
      { id: "q57", text: "Saya bekerja sama dengan orang lain untuk memadukan berbagai pengetahuan ketika mengerjakan proyek STEAM berbasis AiDuNode." },
      { id: "q58", text: "Saya sering meminta masukan dari teman untuk memperkaya ide kreatif saya saat menggunakan AiDuNode." },
      { id: "q59", text: "Berdiskusi dengan tim membantu saya menghasilkan lebih banyak ide inovatif dalam proyek STEAM berbasis AiDuNode." },
      { id: "q60", text: "Diskusi dengan orang lain saat mengerjakan proyek AiDuNode sering memunculkan arah kreatif yang baru bagi saya." },
      { id: "q61", subTitle: "G.4 Orientasi pada Produk Akhir",         text: "Saya senang bereksperimen dengan AiDuNode dalam proyek STEAM saya, walau hasilnya belum tentu langsung terlihat." },
      { id: "q62", text: "Saya lebih suka mengeksplorasi ide melalui AiDuNode ketimbang hanya berfokus pada produk akhir." },
      { id: "q63", text: "Saat menggunakan AiDuNode, saya merasa puas dengan proses kreatifnya sendiri, meski hasil akhirnya belum tampak." },
      { id: "q64", text: "Saya lebih tertarik mencoba ide-ide baru dengan AiDuNode dibandingkan buru-buru menuntaskan produk akhir yang sempurna." },
      { id: "q65", text: "Dalam proyek STEAM, saya lebih menghargai proses belajar melalui eksperimen dengan AiDuNode dibanding hasil akhir semata." },
      { id: "q66", subTitle: "G.5 Kepercayaan atau Kebiasaan Tertentu", text: "Saya kadang memakai fitur AiDuNode tertentu sebagai bagian dari kebiasaan proses kreatif saya dalam proyek STEAM." },
      { id: "q67", text: "Saya memiliki pengaturan atau lingkungan pemrograman tertentu yang saya yakini membantu kreativitas saat memakai AiDuNode." },
      { id: "q68", text: "Saya memiliki rutinitas tertentu yang saya lakukan sebelum memulai proyek dengan AiDuNode agar lebih kreatif." },
      { id: "q69", text: "Saya merasa menggunakan AiDuNode dengan cara tertentu dapat meningkatkan kreativitas saya dalam tugas STEAM." },
      { id: "q70", text: "Saya percaya karya kreatif saya dengan AiDuNode lebih berhasil bila saya mengikuti kebiasaan pribadi tertentu sebelum memulai." },
      { id: "q71", subTitle: "G.6 Pengendalian Lingkungan",             text: "Saya memiliki ruang khusus untuk menggunakan AiDuNode agar lebih kreatif dalam mengerjakan proyek STEAM." },
      { id: "q72", text: "Saya lebih suka menyiapkan lingkungan dan perangkat tertentu untuk mengoptimalkan proses kreatif saya saat memakai AiDuNode." },
      { id: "q73", text: "Ruang kerja yang nyaman dan bebas gangguan membantu saya fokus mengerjakan proyek STEAM dengan AiDuNode." },
      { id: "q74", text: "Hasil kreatif saya dalam proyek berbasis AiDuNode lebih baik ketika saya mengatur pencahayaan, suara, dan perangkat di sekitar saya." },
      { id: "q75", text: "Saya percaya lingkungan kerja yang tertata dengan perangkat IoT dan akses AiDuNode yang baik adalah kunci kreativitas dalam proyek STEAM saya." },
      { id: "q76", subTitle: "G.7 Pemanfaatan Indra",                   text: "Saya memanfaatkan data dari sensor IoT (misalnya suhu, gerak, atau suara) untuk memandu kreativitas saya saat memakai AiDuNode." },
      { id: "q77", text: "Proses kreatif saya dengan AiDuNode sering melibatkan indra visual dan pendengaran untuk menjelajahi ide-ide baru." },
      { id: "q78", text: "Saya memadukan data sensor IoT ke dalam pemikiran kreatif saya guna menyempurnakan solusi dalam tugas STEAM yang dibantu AiDuNode." },
      { id: "q79", text: "Saya berusaha melibatkan berbagai indra saya—penglihatan, sentuhan, dan suara—saat mengerjakan proyek kreatif dengan AiDuNode." },
      { id: "q80", text: "Menggunakan indra saya untuk berinteraksi dengan perangkat IoT dan AiDuNode membantu saya menemukan solusi kreatif dalam proyek STEAM." },
    ],
  },
];



// Skala 1–5; nilai 3 ditampilkan tapi tidak bisa dipilih (netral/disabled)
const SCALE = [
  { value: 1, label: "Sangat Tidak Setuju", short: "1", color: "#ef4444", disabled: false },
  { value: 2, label: "Tidak Setuju",        short: "2", color: "#f97316", disabled: false },
  { value: 3, label: "Netral",              short: "3", color: "#94a3b8", disabled: true  },
  { value: 4, label: "Setuju",              short: "4", color: "#3b82f6", disabled: false },
  { value: 5, label: "Sangat Setuju",       short: "5", color: "#22c55e", disabled: false },
];

const TOTAL_Q = 80;
const ALL_QUESTIONS = SECTIONS.flatMap(s => s.questions);

function ThankYouScreen({ existingData }) {
  const navigate = useNavigate();
  const answers = existingData?.answers || {};
  const values = Object.values(answers).filter(v => v);
  const avg = values.length > 0 ? (values.reduce((a, b) => a + b, 0) / values.length).toFixed(2) : "-";
  const avgLabel = avg >= 4.5 ? "Sangat Baik" : avg >= 3.5 ? "Baik" : avg >= 2.5 ? "Cukup" : "Perlu Ditingkatkan";

  return (
    <div className="survey-thankyou">
      <div className="survey-ty-icon">🎉</div>
      <h2 className="survey-ty-title">Terima Kasih!</h2>
      <p className="survey-ty-sub">Kamu sudah mengisi kuisioner kepuasan AiDuNode.</p>
      <div className="survey-ty-card">
        <div className="survey-ty-stat">
          <span className="survey-ty-stat-val">{values.length}/{TOTAL_Q}</span>
          <span className="survey-ty-stat-label">Pertanyaan dijawab</span>
        </div>
        <div className="survey-ty-divider" />
        <div className="survey-ty-stat">
          <span className="survey-ty-stat-val">{avg}</span>
          <span className="survey-ty-stat-label">Rata-rata skor</span>
        </div>
        <div className="survey-ty-divider" />
        <div className="survey-ty-stat">
          <span className="survey-ty-stat-val">{avgLabel}</span>
          <span className="survey-ty-stat-label">Kategori</span>
        </div>
      </div>
      <p className="survey-ty-note">Responmu sangat berarti untuk pengembangan AiDuNode</p>
      <button className="survey-ty-btn" onClick={() => navigate("/dashboard")}>
        Kembali ke Dashboard
      </button>
    </div>
  );
}

const PENDIDIKAN_OPTIONS = [
  "D3", "D4", "S1", "S2", "S3",
];

export default function Kuisioner() {
  const { user } = useAuth();
  // -1 = slide data diri, 0..N-1 = section kuisioner
  const [currentSection, setCurrentSection] = useState(-1);
  const [profile, setProfile] = useState({ nama: "", umur: "", kampus: "", pendidikan: "", semester: "" });
  const [profileErrors, setProfileErrors] = useState({});
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [existingData, setExistingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [unanswered, setUnanswered] = useState([]);

  useEffect(() => {
    if (!user?.id) return;
    api.get(`/api/survey/check/${user.id}`)
      .then(res => {
        if (res.data.hasSubmitted) {
          setSubmitted(true);
          setExistingData(res.data.data);
        }
      })
      .catch(() => { })
      .finally(() => setLoading(false));
  }, [user]);

  const section = currentSection >= 0 ? SECTIONS[currentSection] : null;
  const totalSections = SECTIONS.length;
  const progress = Math.round((Object.keys(answers).length / TOTAL_Q) * 100);

  // --- Profile form handlers ---
  const handleProfileChange = (field, value) => {
    setProfile(prev => ({ ...prev, [field]: value }));
    setProfileErrors(prev => ({ ...prev, [field]: "" }));
  };

  const handleProfileNext = () => {
    const errs = {};
    if (!profile.nama.trim()) errs.nama = "Nama wajib diisi.";
    if (!profile.umur.trim()) errs.umur = "Umur wajib diisi.";
    else if (isNaN(profile.umur) || Number(profile.umur) < 1)
      errs.umur = "Masukkan umur yang valid.";
    if (!profile.kampus.trim()) errs.kampus = "Nama kampus wajib diisi.";
    if (!profile.pendidikan) errs.pendidikan = "Pilih jenjang pendidikan.";
    if (!profile.semester.trim()) errs.semester = "Semester wajib diisi.";
    else if (isNaN(profile.semester) || Number(profile.semester) < 1)
      errs.semester = "Masukkan semester yang valid.";

    if (Object.keys(errs).length > 0) {
      setProfileErrors(errs);
      return;
    }
    setProfileErrors({});
    setCurrentSection(0);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // --- Survey question handlers ---
  const handleAnswer = (qId, value) => {
    setAnswers(prev => ({ ...prev, [qId]: value }));
    setUnanswered(prev => prev.filter(id => id !== qId));
  };

  const handleNext = () => {
    const missing = section.questions.filter(q => answers[q.id] === undefined).map(q => q.id);
    if (missing.length > 0) {
      setUnanswered(missing);
      setError(`Harap jawab ${missing.length} pertanyaan yang belum dijawab sebelum lanjut.`);
      return;
    }
    setError("");
    setUnanswered([]);
    setCurrentSection(prev => prev + 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePrev = () => {
    setError("");
    setUnanswered([]);
    // Jika di section pertama (0), kembali ke slide data diri (-1)
    setCurrentSection(prev => prev - 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubmit = async () => {
    const missing = section.questions.filter(q => answers[q.id] === undefined).map(q => q.id);
    if (missing.length > 0) {
      setUnanswered(missing);
      setError(`Harap jawab ${missing.length} pertanyaan yang belum dijawab.`);
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      await api.post("/api/survey", { userId: user.id, answers, profile });
      setSubmitted(true);
      setExistingData({ answers });
    } catch (err) {
      setError(err.response?.data?.message || "Terjadi kesalahan saat menyimpan. Coba lagi.");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <div className="survey-loading">
          <div className="survey-spinner" />
          <p>Memuat kuisioner...</p>
        </div>
      </DashboardLayout>
    );
  }

  if (submitted) {
    return (
      <DashboardLayout>
        <ThankYouScreen existingData={existingData} />
      </DashboardLayout>
    );
  }

  // ── Render slide data diri ──────────────────────────────────────────────
  if (currentSection === -1) {
    return (
      <DashboardLayout>
        <div className="survey-page">
          <div className="survey-header">
            <h1 className="survey-title">Kuisioner Kepuasan AiDuNode</h1>
            <p className="survey-subtitle">Bantu kami meningkatkan aplikasi dengan mengisi kuisioner ini</p>
          </div>

          {/* Progress — Data Diri format premium sama seperti slide kuisioner */}
          <div className="survey-progress-wrap">
            <div className="survey-progress-toprow">
              <div className="survey-progress-badge">
                <span className="survey-progress-badge-step">Bagian 1 / {totalSections + 1}</span>
                <span className="survey-progress-badge-dot">•</span>
                <span className="survey-progress-badge-title">Data Diri Responden</span>
              </div>
              <div className="survey-progress-counter">
                <span className="survey-progress-counter-val">0</span>
                <span className="survey-progress-counter-sep">/</span>
                <span className="survey-progress-counter-total">{TOTAL_Q}</span>
              </div>
            </div>
            <div className="survey-progress-bar-wrap">
              <div className="survey-progress-bar">
                <div className="survey-progress-fill" style={{ width: "0%" }} />
              </div>
              <span className="survey-progress-pct-outside">0%</span>
            </div>
            <div className="survey-steps">
              <div className="survey-step active">
                <div className="survey-step-circle">1</div>
                <span className="survey-step-label">Data Diri</span>
              </div>
              {SECTIONS.map((s, i) => {
                const sectionLetter = s.title.split(".")[0].trim();
                return (
                  <div key={i} className="survey-step pending">
                    <div className="survey-step-line" />
                    <div className="survey-step-circle">{sectionLetter}</div>
                    <span className="survey-step-label">{sectionLetter}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Card form data diri */}
          <div className="survey-section-card">
            <div className="survey-section-header">
              <h2 className="survey-section-title">Data Diri Responden</h2>
              <p className="survey-section-desc">Lengkapi informasi berikut sebelum mengisi kuisioner</p>
            </div>

            <div className="survey-profile-form">
              {/* Nama */}
              <div className={`survey-profile-field ${profileErrors.nama ? "has-error" : ""}`}>
                <label className="survey-profile-label">Nama Lengkap <span className="survey-required">*</span></label>
                <input
                  className="survey-profile-input"
                  type="text"
                  placeholder="Masukkan nama lengkap Anda"
                  value={profile.nama}
                  onChange={e => handleProfileChange("nama", e.target.value)}
                />
                {profileErrors.nama && <span className="survey-field-error">{profileErrors.nama}</span>}
              </div>

              {/* Umur */}
              <div className={`survey-profile-field ${profileErrors.umur ? "has-error" : ""}`}>
                <label className="survey-profile-label">Umur <span className="survey-required">*</span></label>
                <input
                  className="survey-profile-input"
                  type="number"
                  min="1"
                  max="100"
                  placeholder="Contoh: 20"
                  value={profile.umur}
                  onChange={e => handleProfileChange("umur", e.target.value)}
                />
                {profileErrors.umur && <span className="survey-field-error">{profileErrors.umur}</span>}
              </div>

              {/* Kampus */}
              <div className={`survey-profile-field ${profileErrors.kampus ? "has-error" : ""}`}>
                <label className="survey-profile-label">Nama Kampus <span className="survey-required">*</span></label>
                <input
                  className="survey-profile-input"
                  type="text"
                  placeholder="Contoh: Universitas Negeri Malang"
                  value={profile.kampus}
                  onChange={e => handleProfileChange("kampus", e.target.value)}
                />
                {profileErrors.kampus && <span className="survey-field-error">{profileErrors.kampus}</span>}
              </div>

              {/* Pendidikan */}
              <div className={`survey-profile-field ${profileErrors.pendidikan ? "has-error" : ""}`}>
                <label className="survey-profile-label">Jenjang Pendidikan <span className="survey-required">*</span></label>
                <select
                  className="survey-profile-input survey-profile-select"
                  value={profile.pendidikan}
                  onChange={e => handleProfileChange("pendidikan", e.target.value)}
                >
                  <option value="">-- Pilih jenjang --</option>
                  {PENDIDIKAN_OPTIONS.map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
                {profileErrors.pendidikan && <span className="survey-field-error">{profileErrors.pendidikan}</span>}
              </div>

              {/* Semester */}
              <div className={`survey-profile-field ${profileErrors.semester ? "has-error" : ""}`}>
                <label className="survey-profile-label">Semester <span className="survey-required">*</span></label>
                <input
                  className="survey-profile-input"
                  type="number"
                  min="1"
                  max="20"
                  placeholder="Contoh: 5"
                  value={profile.semester}
                  onChange={e => handleProfileChange("semester", e.target.value)}
                />
                {profileErrors.semester && <span className="survey-field-error">{profileErrors.semester}</span>}
              </div>
            </div>

            <div className="survey-nav">
              <button className="survey-nav-btn prev" disabled>Sebelumnya</button>
              <span className="survey-nav-counter">1 / {totalSections + 1}</span>
              <button className="survey-nav-btn next" onClick={handleProfileNext}>Selanjutnya</button>
            </div>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  // ── Render slide kuisioner (section 0..N-1) ─────────────────────────────
  return (
    <DashboardLayout>
      <div className="survey-page">
        <div className="survey-header">
          <h1 className="survey-title">Kuisioner Kepuasan AiDuNode</h1>
          <p className="survey-subtitle">Bantu kami meningkatkan aplikasi dengan mengisi kuisioner ini</p>
        </div>

        {/* ── Premium Progress Block ── */}
        <div className="survey-progress-wrap">
          {/* Top row: section label + question counter */}
          <div className="survey-progress-toprow">
            <div className="survey-progress-badge">
              <span className="survey-progress-badge-step">Bagian {currentSection + 2} / {totalSections + 1}</span>
              <span className="survey-progress-badge-dot">•</span>
              <span className="survey-progress-badge-title">{section.title}</span>
            </div>
            <div className="survey-progress-counter">
              <span className="survey-progress-counter-val">{Object.keys(answers).length}</span>
              <span className="survey-progress-counter-sep">/</span>
              <span className="survey-progress-counter-total">{TOTAL_Q}</span>
            </div>
          </div>

          {/* Progress bar with percentage label */}
          <div className="survey-progress-bar-wrap">
            <div className="survey-progress-bar">
              <div className="survey-progress-fill" style={{ width: `${progress}%` }}>
                {progress > 10 && (
                  <span className="survey-progress-pct-inline">{progress}%</span>
                )}
              </div>
            </div>
            {progress <= 10 && (
              <span className="survey-progress-pct-outside">{progress}%</span>
            )}
          </div>

          {/* Step indicators */}
          <div className="survey-steps">
            {/* Step 0 = Data Diri (always done) */}
            <div className="survey-step done">
              <div className="survey-step-circle">✓</div>
              <span className="survey-step-label">Data Diri</span>
            </div>
            {SECTIONS.map((s, i) => {
              const state = i < currentSection ? "done" : i === currentSection ? "active" : "pending";
              const sectionLetter = s.title.split(".")[0].trim();
              return (
                <div key={i} className={`survey-step ${state}`}>
                  {i > 0 && <div className={`survey-step-line ${i <= currentSection ? "done" : ""}`} />}
                  <div className="survey-step-circle">
                    {state === "done" ? "✓" : sectionLetter}
                  </div>
                  <span className="survey-step-label">{sectionLetter}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="survey-section-card">
          <div className="survey-section-header">
            <h2 className="survey-section-title">{section.title}</h2>
            <p className="survey-section-desc">{section.description}</p>
          </div>

          <div className="survey-legend">
            {SCALE.map(s => (
              <div key={s.value} className={`survey-legend-item ${s.disabled ? "legend-disabled" : ""}`}>
                <span
                  className="survey-legend-badge"
                  style={{
                    background: s.color + "22",
                    color: s.disabled ? s.color + "66" : s.color,
                    border: `1px solid ${s.disabled ? s.color + "44" : s.color}`,
                    textDecoration: s.disabled ? "line-through" : "none",
                    opacity: s.disabled ? 0.5 : 1,
                  }}
                >
                  {s.short}
                </span>
                <span className="survey-legend-label" style={{ opacity: s.disabled ? 0.5 : 1 }}>
                  {s.label}{s.disabled ? " (tidak tersedia)" : ""}
                </span>
              </div>
            ))}
          </div>

          <div className="survey-questions">
            {section.questions.map((q) => {
              const globalIdx = ALL_QUESTIONS.findIndex(aq => aq.id === q.id) + 1;
              const isUnanswered = unanswered.includes(q.id);
              return (
                <div key={q.id}>
                  {q.subTitle && (
                    <div className="survey-subsection-header">
                      <span className="survey-subsection-title">{q.subTitle}</span>
                    </div>
                  )}
                  <div className={`survey-q-row ${isUnanswered ? "unanswered" : ""} ${answers[q.id] ? "answered" : ""}`}>
                    <div className="survey-q-text">
                      <span className="survey-q-num">{globalIdx}.</span>
                      <span>{q.text}</span>
                      {isUnanswered && <span className="survey-q-required">* Wajib diisi</span>}
                    </div>
                    <div className="survey-scale-row">
                      {SCALE.map(s => (
                        <button
                          key={s.value}
                          className={`survey-scale-btn ${answers[q.id] === s.value ? "selected" : ""} ${s.disabled ? "disabled-neutral" : ""}`}
                          style={
                            s.disabled
                              ? { borderColor: s.color + "44", color: s.color + "88", background: "#f8fafc", cursor: "not-allowed", opacity: 0.5 }
                              : answers[q.id] === s.value
                              ? { background: s.color, borderColor: s.color, color: "#fff" }
                              : { borderColor: s.color + "55", color: s.color }
                          }
                          onClick={() => !s.disabled && handleAnswer(q.id, s.value)}
                          disabled={s.disabled}
                          title={s.disabled ? `Nilai ${s.value} (Netral) tidak tersedia` : s.label}
                        >
                          <span className="survey-scale-short">{s.short}</span>
                          <span className="survey-scale-full">{s.disabled ? "(tidak tersedia)" : s.label}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {error && <div className="survey-error">⚠️ {error}</div>}

          <div className="survey-nav">
            <button className="survey-nav-btn prev" onClick={handlePrev} disabled={currentSection === 0}>
              Sebelumnya
            </button>
            <span className="survey-nav-counter">{currentSection + 2} / {totalSections + 1}</span>
            {currentSection < totalSections - 1 ? (
              <button className="survey-nav-btn next" onClick={handleNext}>Selanjutnya</button>
            ) : (
              <button className="survey-nav-btn submit" onClick={handleSubmit} disabled={submitting}>
                {submitting ? "Menyimpan..." : "Kirim Kuisioner"}
              </button>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
